module.exports = __webpack_public_path__ + "static/media/android.c2757619.svg";